import HttpClient from "./httpclient";
import 'regenerator-runtime/runtime';
let totalpages = 15;
let currentPage = 1;
let selectedAreas = [];
let selectedTags = [];
let selectedGrades = [];
let selectedThemes = [];
let selectedLevels = [];
let selectedDurations = [];
let selectedFamilys = [];
let selectedActivityLevels = [];
let selectedTravelConsultants = [];
let selectedDestinations = [];
let selectedTab = "";
let filterValue = "";
let isSearch = false;
let queryString = "";
let searchSettings = null;
let updatePageMethod = null;
let reAttachFilterOptionsMethod = null;
let reAttachPaginationLinksMethod = null;
let reAttachMobileFilterOptionsMethod = null;
let onsiteSearchCategory = "";

export const PaginatedData = {
    getPaginationData: async (url, method) => {
        return await HttpClient.AsyncGetRequest(url, method)
            .then(result => (JSON.parse(result)))
            .catch(error => {
                console.error(error)
            });
    },
    //sets the callback from PaginatedContent.js. This is set after the method bound and then can used in a page that needs to update it's instance of pagination navigation
    setUpdatePagination: (updateMethod) => {
        updatePageMethod = updateMethod;
    },
    //this is to open up updating the pagination navigation to all pages that use filters. This prevents from having to make multiple instances and can be updated more dynamically.
    updatePagination: (currentPage, itemsPerPage, totalPage, resultType) => {
        if (updatePageMethod) {
            updatePageMethod(currentPage, itemsPerPage, totalPage, resultType);
        }
    },
    //sets a callback for re-attaching teh event listeners to the filter drop downs, this needs to happen as in the keyword search functionality we are overwriting the dropdowns and they are losing the event listeners assigned to them.
    SetReAttachFilterOptions(reAttachFilterOptions) {
        reAttachFilterOptionsMethod = reAttachFilterOptions;
    },

    UpdateReAttachFilterOptions() {
        if (reAttachFilterOptionsMethod) {
            reAttachFilterOptionsMethod();
        }
    },

    setReAttachPaginationLinks(reAttachPaginationLinks) {
        reAttachPaginationLinksMethod = reAttachPaginationLinks;
    },

    UpdateReAttachPaginationLinks() {
        if (reAttachPaginationLinksMethod) {
            reAttachPaginationLinksMethod();
        }
    },

    SetReAttachMobileFilterOptions(reAttachMobileFilterOptions) {
        reAttachMobileFilterOptionsMethod = reAttachMobileFilterOptions;
    },

    UpdateReAttachMobileFilterOptions() {
        if (reAttachMobileFilterOptionsMethod) {
            reAttachMobileFilterOptionsMethod();
        }
    },

    getTab: () => {
        return selectedTab;
    },

    setTab: (tab) => {
        selectedTab = tab;
    },

    getCurrentPage: () => {
        return currentPage;
    },

    setCurrentPage: (page) => {
        currentPage = page;
    },

    getTotalPages: () => {
        return totalpages;
    },

    setTotalPages: (pageNumber) => {
        totalpages = pageNumber;
    },

    getOnsiteSearchCategory: () => {
        return onsiteSearchCategory;
    },

    setOnsiteSearchCategory: (category) => {
        onsiteSearchCategory = category;
    },

    getSelectedGrades: () => {
        return selectedGrades;
    },

    setSelectedGrades: (grades) => {
        selectedGrades = grades;
    },

    setSelectedThemes: (themes) => {
        selectedThemes = themes;
    },

    getSelectedThemes: () => {
        return selectedThemes;
    },

    setSelectedLevels: (levels) => {
        selectedLevels = levels;
    },

    getSelectedLevels: () => {
        return selectedLevels;
    },

    setSelectedDurations: (durations) => {
        selectedDurations = durations;
    },

    getSelectedDurations: () => {
        return selectedDurations;
    },
    setSelectedFamilys: (familys) => {
        selectedFamilys = familys;
    },

    getSelectedFamilys: () => {
        return selectedFamilys;
    },

    setSelectedActivityLevels: (activity) => {
        selectedActivityLevels = activity;
    },

    getSelectedActivityLevels: () => {
        return selectedActivityLevels;
    },

    setSelectedTravelConsultants: (travelConsultant) => {
        selectedTravelConsultants = travelConsultant;
    },

    getSelectedTravelConsultants: () => {
        return selectedTravelConsultants;
    },

    setSelectedDestinations: (destination) => {
        selectedDestinations = destination;
    },

    getSelectedDestinations: () => {
        return selectedDestinations;
    },

    getSelectedAreas: () => {
        return selectedAreas;
    },

    setSelectedAreas: (areas) => {
        selectedAreas = areas;
    },

    getSelectedTags: () => {
        return selectedTags;
    },

    setSelectedTags: (tags) => {
        selectedTags = tags;
    },

    getFilter: () => {
        return filterValue;
    },

    setFilter: (selectedFilter) => {
        filterValue = selectedFilter;
    },

    getSearchflag: () => {
        return isSearch;
    },

    setSearchflag: (value) => {
        isSearch = value;
    },

    getURLqueryString: () => {
        return queryString;
    },

    setURLqueryString: (q) => {
        queryString = q;
    },

    resetFiltersOnTabChange: () => {
        PaginatedData.setSelectedAreas([]);
        PaginatedData.setSelectedTags([]);
        PaginatedData.setSelectedGrades([]);
        PaginatedData.setSelectedThemes([]);
        PaginatedData.setSelectedLevels([]);
        PaginatedData.setSelectedDurations([]);
        PaginatedData.setSelectedFamilys([]);
        PaginatedData.setSelectedActivityLevels([]);
        PaginatedData.setSelectedTravelConsultants([]);
        PaginatedData.setSelectedDestinations([]);
    },

    //Used to SET the search settings state globally to pass between the content and filters
    setSearchSettings: (params) => {
        searchSettings = params;
    },
    //Used to GET the search settings state globally to pass between the content and filters
    getSearchSettings: () => {
        return searchSettings;
    },

    // Set the the filtered result type eg. "1 - 10 of 90 Hotels" on the filters.
    // Currently being used in separate instances per tab ('properties', 'itineraries' etc..)
    // so the spans are handled separately to not interfere with other tabs in cases of multiple tabs.
    getFilteredResultCount: (count, type, contentID, currentPageNo) => {
        let filterResults = [];
        let resultType = '';

        //set filter results based on the tab using the contentID retrieved from the 'data-pagination-id' attribute
        if (contentID == "content-1") {
            filterResults = document.querySelectorAll(".tab-experiences .sd-filter__results-count");
        } else if (contentID == "content-2") {
            filterResults = document.querySelectorAll(".tab-properties .sd-filter__results-count");
        } else if (contentID == "content-3") {
            filterResults = document.querySelectorAll(".tab-itineraries .sd-filter__results-count");
        }
        const itemsPerPageElement = document.querySelector('[data-itemsperpage]');
        let itemsPerPage = 10;
        if (itemsPerPageElement != null) {
            itemsPerPage = parseInt(itemsPerPageElement.getAttribute('data-itemsperpage'));
        }
        if (filterResults.length > 0) {
            [...filterResults].forEach((filterResult) => {
                const span = document.createElement("span");
                span.classList.add("sd-subtitle");
                const endItem = (count < itemsPerPage || count < currentPageNo * itemsPerPage) ? count : itemsPerPage * currentPageNo;
                const startItem = count < itemsPerPage ? 1 : (itemsPerPage * (currentPageNo - 1) + 1);

                // Adjusting the type based on count for plural or singular
                if (count === 1) {
                    if (type == "Things to Do") {
                        resultType = "Thing to Do";
                    } else if (type == "Hotels") {
                        resultType = "Hotel";
                    } else if (type == "Tour Ideas") {
                        resultType = "Tour Idea";
                    }
                } else {
                    resultType = type;
                }
                // Set innerHTML to display correctly per tab on screen.
                span.textContent = `${startItem} - ${endItem} of ${count} ${resultType}`;
                filterResult.innerHTML = "";
                filterResult.appendChild(span);
            });
        }
    }
};
export default PaginatedData;